enum actionTypes {
  FETCH_PARKING = 'FETCH_PARKING',
  FETCH_PARKING_TYPES = 'FETCH_PARKING_TYPES',
}

export default actionTypes;
